import { APIClient } from "./api_helper";
import * as url from "./url_helper";

const api = new APIClient();

// Project management API functions
const projectsApi = {
  // Get all projects
  getProjectList: () => api.get(url.GET_PROJECT_LIST),

  // Add a new project
  addProjectList: (project: any) => api.create(url.ADD_NEW_PROJECT, project),

  // Update a project
  updateProjectList: (project: any) => api.put(url.UPDATE_PROJECT, project),

  // Delete a project
  deleteProjectList: (project: any) => api.delete(url.DELETE_PROJECT, { headers: { project } })
};

export { projectsApi };
